import { FlightState, TypeFare, TypeFlight } from "@/lib/redux/features/flight/type"
import { getDisplayedAirlineCode } from "@/utils/flight/getDisplayedAirlineCode"

export const byAirline = (state: FlightState, flight: TypeFlight, fareData: TypeFare) => {
  const airlines = state.flightsResult.filters.airlines || []
  if (airlines.length <= 0) {
    return true
  }

  const airline = getDisplayedAirlineCode(state, flight, fareData)

  return airlines.indexOf(airline) > -1
}